<div class="modal-header" appCustomAutofocus>
    <h3>Time Worked Details</h3>
</div>
<div class="modal-body">
    <div style="margin-bottom:8px">
        <span *ngIf="isStartTime"><b>{{selectedDay.StartTime}}</b></span>
        <span *ngIf="!isStartTime"><b>{{selectedDay.StopTime}}</b></span>
    </div>
    <div style="margin-bottom:8px">
        <span *ngIf="loadingAttachment">
            <img src="/Cache/images/icon_load.gif" alt="Loading..." />
        </span>
        <span *ngIf="dailyTimeAttachmentData != null">
            <img [src]="dailyTimeAttachmentData" style="margin-left: 10px;"  [style.max-width.px]="maxWidth" />
        </span>
    </div>
    <div>
        <label><strong>Note:&nbsp;</strong></label>
        <span>{{selectedDay.Notes}}</span>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-outline-dark"
            (click)="cancelClicked()">
        Close
    </button>
</div>